export default "__VITE_ASSET__T4m$FcLm__"